import { Document, Page, pdfjs } from 'react-pdf';
import 'react-pdf/dist/Page/AnnotationLayer.css';
import 'react-pdf/dist/Page/TextLayer.css';
import { useScreenWidth } from '../hooks/useWidth';
import { SMALL_WIDTH } from '../utils/constants';

pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.min.js`;

export const PDFViewer = ({ url }) => {
  const resumeURL = encodeURI(url)
  const width = useScreenWidth()
  return (
    <div className=" bg-white/50 w-full h-screen overflow-auto flex justify-center bg-gray-100 mx-2">
      <Document file={resumeURL} 
            onLoadError={(error) => console.error('PDF load error', error)}
        onSourceError={(error) => console.error('Source error', error)} >
        <Page pageNumber={1} width={width < SMALL_WIDTH ? 350: 550} />
      </Document>
    </div>
  );
}
